module.exports = __webpack_public_path__ + "media/images/lp_cv-0-1f3e9458476c02c6c6d0abbe7a2a50de.webp";